// ---------------------------------------------------------

import dynamic from 'next/dynamic';

// ---------------------------------------------------------

const Accordion = dynamic(() => import('@components/accordion'));
const AgentFinder = dynamic(() => import('@components/agent-finder'));
const ArticleCard = dynamic(() => import('@components/article-card'));
const Button = dynamic(() => import('@components/button'));
const BuysideWidget = dynamic(() => import('@components/buyside-widget'));
const Calculators = dynamic(() => import('@components/calculators'));
const Callout = dynamic(() => import('@components/callout'));
const Category = dynamic(() => import('@components/category'));
const Container = dynamic(() => import('@layout/container'));
const ContentModal = dynamic(() => import('@components/content-modal'));
const DynamicForm = dynamic(() => import('@components/form'));
const FeaturedContent = dynamic(() => import('@components/featured-content'));
const FeaturedEvents = dynamic(() => import('@components/featured-events'));
const FeaturedListings = dynamic(() => import('@components/featured-listings'));
const Forms = dynamic(() => import('@components/forms'));
const Image = dynamic(() => import('@components/image/block-image'));
const Jumbotron = dynamic(() => import('@components/jumbotron'));
const OfficeSearch = dynamic(() => import('@components/agent-finder/search-by-office'));
const PeopleCard = dynamic(() => import('@components/people-card'));
const PostList = dynamic(() => import('@components/post-list'));
const PostListWithFeatured = dynamic(() => import('@components/post-list-with-featured'));
const Quad = dynamic(() => import('@components/quad'));
const SellWithSibcy = dynamic(() => import('@components/sell-with-sibcy'));
const TextBlock = dynamic(() => import('@components/text-block'));
const TopicCarousel = dynamic(() => import('@components/topic-carousel'));
const Video = dynamic(() => import('@components/video'));

import styles from './styles.module.scss';
const { center_button } = styles;

// ---------------------------------------------------------

export default {
  Accordion,
  AgentFinder,
  ArticleCard,
  BlockContactForm: Forms,
  BuysideWidget,
  Calculator: Calculators,
  CallOut: Callout,
  Category,
  Community: FeaturedContent,
  Cta: (props) => (
    <div className={center_button}>
      <Button {...props} />
    </div>
  ),
  Modal: (props) => <ContentModal {...props} />,
  FeaturedPost: FeaturedContent,
  DynamicContactForm: DynamicForm,
  Forms,
  Grid: Container,
  Jumbotron,
  ModuleContentBlock: TextBlock,
  ModuleImage: Image,
  ModuleQuad: Quad,
  ModuleVideo: Video,
  OfficeSearch,
  PostBlog: FeaturedContent,
  PostBlogCategory: Category,
  PostList,
  PostListWithFeatured,
  SellWithSibcy,
  TopicCarousel,
  TopicPage: FeaturedContent,
  TopicRecord: FeaturedContent,
  BlockFeaturedListings: FeaturedListings,
  BlockPerson: PeopleCard,
  FeaturedEvents,
  EventRecord: FeaturedContent
};
